import React, { useMemo } from 'react'

import RecipeCookingSupporting from '../../components/RecipeCookingSupporting'
import Meta from '../../components/Meta'
import { formatRecipe } from '../../helpers'
import { useTranslation } from '../../contexts/I18nContext'

import Styled from './GoneRecipePage.styled'

const GoneRecipePage = ({ similarRecipes, featuredRecipes, title }) => {
  const { t } = useTranslation()

  const formattedSimilarRecipes = useMemo(() => {
    if (similarRecipes?.length) {
      return similarRecipes.map((similar) =>
        formatRecipe({
          ...similar,
          coversCount: similar.coversCount || 2,
        }),
      )
    }
    return []
  }, [similarRecipes])

  const formattedFeaturedRecipes = useMemo(() => {
    if (featuredRecipes?.length) {
      return featuredRecipes.map((similar) =>
        formatRecipe({
          ...similar,
          coversCount: similar.coversCount || 2,
        }),
      )
    }
    return []
  }, [featuredRecipes])

  return (
    <>
      <Meta title={title}>
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex" />
      </Meta>
      <Styled>
        <Styled.content>
          <Styled.title>{t('ERROR.GONE_RECIPE_TITLE')}</Styled.title>
          <Styled.separator />
          {formattedSimilarRecipes.length > 1 ? (
            <>
              <Styled.subtitle>
                {t('ERROR.GET_SIMILAR_RECIPES')}
              </Styled.subtitle>
              <Styled.recipes centered variant="recipe-card">
                {formattedSimilarRecipes.map((similarRecipe) => (
                  <Styled.recipesItem key={similarRecipe.id}>
                    <Styled.recipeCard
                      imageUrl={similarRecipe.imageUrl}
                      coversCount={similarRecipe.coversCount}
                      id={similarRecipe.id}
                      isLoading={false}
                      title={similarRecipe.title}
                      description={similarRecipe.composition}
                      slug={similarRecipe.slug}
                      source={similarRecipe.source}
                      roundedCoversCount={similarRecipe.roundedCoversCount}
                      unitName={similarRecipe.unitName}
                      tagsEdito={similarRecipe.tagsEdito}
                      missingIngredients={similarRecipe.missingIngredients}
                      prefetch={false}
                    >
                      <RecipeCookingSupporting
                        id={similarRecipe.id}
                        title={similarRecipe.title}
                        slug={similarRecipe.slug}
                        coversCount={similarRecipe.coversCount}
                        source={similarRecipe.source}
                      />
                    </Styled.recipeCard>
                  </Styled.recipesItem>
                ))}
              </Styled.recipes>
            </>
          ) : formattedFeaturedRecipes.length > 0 ? (
            <>
              <Styled.subtitle>{t('ERROR.LATEST_RECIPES')}</Styled.subtitle>
              <Styled.recipes centered variant="recipe-card">
                {formattedFeaturedRecipes.map((featuredRecipe) => (
                  <Styled.recipesItem key={featuredRecipe.id}>
                    <Styled.recipeCard
                      imageUrl={featuredRecipe.imageUrl}
                      coversCount={featuredRecipe.coversCount}
                      id={featuredRecipe.id}
                      isLoading={false}
                      title={featuredRecipe.title}
                      description={featuredRecipe.composition}
                      slug={featuredRecipe.slug}
                      source={featuredRecipe.source}
                      roundedCoversCount={featuredRecipe.roundedCoversCount}
                      unitName={featuredRecipe.unitName}
                      tagsEdito={featuredRecipe.tagsEdito}
                      missingIngredients={featuredRecipe.missingIngredients}
                      prefetch={false}
                    >
                      <RecipeCookingSupporting
                        id={featuredRecipe.id}
                        title={featuredRecipe.title}
                        slug={featuredRecipe.slug}
                        coversCount={featuredRecipe.coversCount}
                        source={featuredRecipe.source}
                      />
                    </Styled.recipeCard>
                  </Styled.recipesItem>
                ))}
              </Styled.recipes>
            </>
          ) : null}
        </Styled.content>
      </Styled>
    </>
  )
}

GoneRecipePage.defaultProps = {
  title: '',
  similarRecipes: [],
  featuredRecipes: [],
}

export default GoneRecipePage
